import { IconMessage, IconMessagePlus } from '@tabler/icons-react'

import { AstraChip, AstraIcon } from '~/astra'

export const CommentIndicator = ({ commentCount, onClick }: { commentCount?: number; onClick?: () => void }) => {
    const resolvedCountLabel = commentCount && commentCount > 0 ? (commentCount > 99 ? '99+' : commentCount.toString()) : undefined
    const showNewComment = !commentCount || commentCount < 1
    return (
        <AstraChip
            color={showNewComment ? 'default-interactive' : 'info-interactive'}
            size="small"
            variant={showNewComment ? 'outlined' : 'filled'}
            data-test="comment-icon"
            icon={<AstraIcon icon={showNewComment ? IconMessagePlus : IconMessage} />}
            onClick={onClick ?? (() => {})}
            label={resolvedCountLabel}
        />
    )
}
